import { actionSetScenePreloadState } from '../../state/scene/sceneActions';
import swiperService from '../../services/swiper';
import sceneService from '../../services/scene';
import { thunkSetSelectableColors } from '../../services/swiper/common';

const init = () => (dispatch: any, getState: any) => {
  swiperService
    .getSceneInitFunctions()
    .forEach((func: any) => dispatch(func()));

  dispatch(thunkSetSelectableColors());
  dispatch(actionSetScenePreloadState(true));
  dispatch(sceneService.sceneReady());
};

export default init;
